export enum ImportStatusUI {
  Pending = 1,
  InProgress = 2,
  Error = 3,
  Imported = 4,
  Warning = 5,
}
